// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3MVvH","search":"Settings_search__24kGT","filter":"Settings_filter__2W_WU"};